export default {
    setData(state, v) {
        state.data = v;
    },  

    // 标题 
    setLocation(state, v) {
        state.location = v;
    },  
       
}